import Vue from "vue";
import routes from "./router/router";
import createRouter from './router/create-routes';
import App from "./App";

Vue.config.productionTip = false;

const rootElement = document.getElementById('DataQualityScoreMS');
const startRoute = rootElement.dataset.startRoute || 'error';
const dqsRequestId = rootElement.dataset.dqsRequestId || null;
const studyIds = rootElement.dataset.avgStudyIds || '';

const routerSettings = {
	name: startRoute,
	id: rootElement.id,
	requestId: dqsRequestId,
	studyIds: studyIds
};

/* eslint-disable no-new */
new Vue({
	el: "#DataQualityScoreMS",
	render: h => h(App),
	router: createRouter(routes, routerSettings)
});
